import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ContractorTransfer } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<ContractorTransfer, Error, number>, 'mutationKey' | 'mutationFn'>
}

export const useCancelContractorTransferRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<ContractorTransfer, Error, number>(
    [Entities.ContractorTransfers, 'cancel'],
    async (transferId: number) => {
      const { data } = await api.v1AdminContractorTransfersTransferIdCancelPost(transferId)
      return data as unknown as ContractorTransfer
    },
    { ...options }
  )
}
